/*!
 * @license: MIT
 * Copyright (c) 2020 Shanord Inc.
 * https://shanord.com
 */
import {AboutVideo} from '@components/AboutVideo';
import {Accordion} from '@components/Accordion';
import {AnchorScroll} from '@components/AnchorScroll';
import {Backdrop} from '@components/Backdrop';
import {Body} from '@components/Body';
import {Collapse} from '@components/Collapse';
import {Contact} from '@components/Contact';
import {ContactForm} from '@components/ContactForm';
import {EngineerBase} from '@components/EngineerBase';
import {FirstViewElement} from '@components/FirstViewElement';
import {FirstViewScroll} from '@components/FirstViewScroll';
import {FirstViewScrolledAnimation} from '@components/FirstViewScrolledAnimation';
import {HamburgerButton} from '@components/HamburgerButton';
import {Header} from '@components/Header';
import {HeaderNav} from '@components/HeaderNav';
import {HeaderNavDisplay} from '@components/HeaderNavDisplay';
import {HorizontalScroll} from '@components/HorizontalScroll';
import {Hover} from '@components/Hover';
import {HoverContent} from '@components/HoverContent';
import {Image} from '@components/Image';
import {InterviewList} from '@components/InterviewList';
import {Kv} from '@components/Kv';
import {KvSlider} from '@components/KvSlider';
import {KvVideo} from '@components/KvVideo';
import {Nav} from '@components/Nav';
import {NavDesktop} from '@components/NavDesktop';
import {News} from '@components/News';
import {OneView} from '@components/OneView';
import {PageIndicator} from '@components/PageIndicator';
import ParallaxAnimation from '@components/ParallaxAnimation';
import {PeopleFilter} from '@components/PeopleFilter';
import {PeopleList} from '@components/PeopleList';
import {PreloadImage} from '@components/PreloadImage';
import {ProgressAnimation} from '@components/ProgressAnimation';
import {ScrollableImage} from '@components/ScrollableImage';
import {ServiceFeatures} from '@components/ServiceFeatures';
import ServiceItems from '@components/ServiceItems';
import {ServiceItemsDesktop} from '@components/ServiceItemsDesktop';
import {SiteIndicator} from '@components/SiteIndicator';
import {Symbol} from '@components/Symbol';
import {TextViewportAnimation} from '@components/TextViewportAnimation';
import {TrainingItem} from '@components/TrainingItem';
import {TrainingsDialog} from '@components/TrainingsDialog';
import {ViewportAnimation} from '@components/ViewportAnimation';
import ViewportElement from '@components/ViewportElement';
import {Voice} from '@components/Voice';
import {VoicesDialog} from '@components/VoicesDialog';
import {WindowHeight} from '@components/WindowHeight';
import {Wrapper} from '@components/Wrapper';
import {AgeGroup} from '@components/chart/AgeGroup';
import {ChartCountup} from '@components/chart/ChartCountup';
import {ChartSales} from '@components/chart/ChartSales';
import {ChartSections} from '@components/chart/ChartSection';
import {ChartStaff} from '@components/chart/ChartStaff';
import {ChartGender} from '@components/chart/GenderRatio';
import {createApplicationInitializer} from '@services/ApplicationInitializer';

/* eslint-disable sort-keys */
const appInitializer = createApplicationInitializer({
  // common
  '.js-wrapper': Wrapper,
  '.js-site-indicator': SiteIndicator,
  '.js-page-indicator': PageIndicator,
  '.js-form': ContactForm,
  '.js-viewport': ViewportAnimation,
  '.js-viewport-element': ViewportElement,
  '.js-preload-image': PreloadImage,
  '.js-image': Image,
  '.js-hamburger-button': HamburgerButton,
  '.js-collapse': Collapse,
  '.js-accordion': Accordion,
  '.js-window-height': WindowHeight,
  '.js-hover': Hover,
  'a[href^="#"]': AnchorScroll,
  // app
  '.js-body': Body,
  '.js-text': TextViewportAnimation,
  '.js-backdrop': Backdrop,
  '.js-news': News,
  '.js-service-items': ServiceItems,
  '.js-service-items-desktop': ServiceItemsDesktop,
  '.js-hover-content': HoverContent,
  '.js-horizontal-scroll': HorizontalScroll,
  '.js-parallax': ParallaxAnimation,
  '.js-one-view': OneView,
  '.js-kv': Kv,
  '.js-kv-video': KvVideo,
  '.js-kv-slider': KvSlider,
  '.js-header': Header,
  '.js-header-nav': HeaderNav,
  '.js-header-nav-display': HeaderNavDisplay,
  '.js-nav': Nav,
  '.js-nav-desktop': NavDesktop,
  '.js-firstview-element': FirstViewElement,
  '.js-contact': Contact,
  '.js-about-video': AboutVideo,
  '.js-progress-animation': ProgressAnimation,
  '.js-symbol': Symbol,
  '.js-service-features': ServiceFeatures,
  '.js-firstview-scrolled-animation': FirstViewScrolledAnimation,
  '.js-firstview-scroll': FirstViewScroll,
  '.js-gender-ratio': ChartGender,
  '.js-chart-countup': ChartCountup,
  '.js-age-group': AgeGroup,
  '.js-chart-sales': ChartSales,
  '.js-chart-staff': ChartStaff,
  '.js-chart-sections': ChartSections,
  '.js-interview-list': InterviewList,
  '.js-people-filter': PeopleFilter,
  '.js-people-list': PeopleList,
  '.js-scrollable-image': ScrollableImage,
  '.js-voice': Voice,
  '.js-voices-dialog': VoicesDialog,
  '.js-training-item': TrainingItem,
  '.js-trainings-dialog': TrainingsDialog,
  '.js-engineer-base': EngineerBase,
});
/* eslint-enable sort-keys */

appInitializer.init();
